import React, { useState } from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import { useMutation } from 'react-query';
import { VesselsAPI } from '../services/vessels.ts';
import { ArrowRightOnRectangleIcon } from '@heroicons/react/24/outline';
import BoatIcon from '../components/icons/BoatIcon.tsx';

const VesselSale: React.FC = () => {
  const navigate = useNavigate();
  const { id } = useParams();
  const [sellingPrice, setSellingPrice] = useState<number>(0);
  const [soldDate, setSoldDate] = useState<string>(new Date().toISOString().split('T')[0]);

  const saleMutation = useMutation(async () => {
    if (!id) return;
    await VesselsAPI.sell(Number(id), { sellingPrice, soldDate });
  }, {
    onSuccess: () => {
      navigate(`/vessels/${id}`);
    },
    onError: err => {
      console.error('Erro ao registrar venda:', err);
      alert('Erro ao registrar venda. Verifique os dados.');
    }
  });

  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault();
    saleMutation.mutate();
  };

  return (
    <div className="space-y-8">
      <div className="flex items-center justify-between">
        <h1 className="text-3xl font-bold text-gray-900 flex items-center">
          <BoatIcon className="h-8 w-8 mr-3 text-blue-600" />
          Registrar Venda
        </h1>
      </div>

      <form onSubmit={handleSubmit} className="bg-white rounded-2xl shadow-lg border border-gray-100 p-6 space-y-6">
        <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
          <div>
            <label className="block text-sm font-medium text-gray-700">Valor de Venda</label>
            <input type="number" step="0.01" value={sellingPrice} onChange={e => setSellingPrice(Number(e.target.value))} required className="mt-1 w-full px-4 py-2 border rounded-xl" />
          </div>
          <div>
            <label className="block text-sm font-medium text-gray-700">Data de Venda</label>
            <input type="date" value={soldDate} onChange={e => setSoldDate(e.target.value)} required className="mt-1 w-full px-4 py-2 border rounded-xl" />
          </div>
        </div>

        <div className="flex justify-end gap-2">
          <button type="button" onClick={() => navigate(`/vessels/${id}`)} className="px-4 py-2 border rounded-xl">Cancelar</button>
          <button type="submit" disabled={saleMutation.isLoading} className="px-4 py-2 bg-green-600 text-white rounded-xl hover:bg-green-700 disabled:opacity-50">
            <ArrowRightOnRectangleIcon className="h-4 w-4 inline mr-1" /> Registrar
          </button>
        </div>
      </form>
    </div>
  );
};

export default VesselSale;